import * as React from 'react';

function SvgVideocamOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.418, d: "M17.303 14.358l3.693 2.599A.713.713 0 0022 16.304V7.7a.714.714 0 00-1.004-.653l-3.693 2.6a.715.715 0 00-.303.583v3.545a.715.715 0 00.303.584v0z" }),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.418, d: "M12.536 17.716H4.32A2.328 2.328 0 012 15.394V8.61a2.328 2.328 0 012.321-2.322h8.236a2.307 2.307 0 012.3 2.3v6.807a2.328 2.328 0 01-2.321 2.322z" })));
}

export default SvgVideocamOutline;
